module.exports = __webpack_public_path__ + "img/collection-1.26beb484.png";